import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import EnggTasksDetails from './enggTasksDetails';
import { getList } from 'services/redux/networkEngineer/action';

const mapStateToProps = (state) => ({
    taskList: state.NetEnggReducer.taskList,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getList
        },
        dispatch
    );


export default connect(mapStateToProps, mapDispatchToProps)(EnggTasksDetails);